export const isTestCandidates = process.env.VUE_APP_SATELLITE === 'testcandidates'

export function trackCommercial(gtm, event, params = {}) {
  if (!gtm) return
  try { gtm.trackEvent({ event, measurement_definition: 'tc-commercial-v1', audience: 'employer', ...params }) } catch (_) {}
}

export function trackConfirmedPayment(gtm, payment, storage) {
  if (!payment || !/^(in|pi)_[A-Za-z0-9]+$/.test(payment.transaction_id || '') || !/^[A-Z]{3}$/.test(payment.currency || '') || !Number.isFinite(payment.value) || payment.value <= 0) return
  const key = `tc-confirmed-payment:${payment.transaction_id}`
  try { if (storage && storage.getItem(key)) return } catch (_) {}
  trackCommercial(gtm, 'ga4_purchase', payment)
  // GA4's canonical transaction ID also deduplicates across tabs. This merely prevents refresh noise.
  try { if (storage && gtm) storage.setItem(key, '1') } catch (_) {}
}
